const XLRG_IMAGE = '(min-width: 1160px)',
    LRG_IMAGE = '(min-width: 900px)',
    MED_IMAGE = '(min-width: 600px)',
    SML_IMAGE = '(min-width: 320px)',
    DPR_1 = 'dpr_1.0',
    DPR_2 = 'dpr_2.0',
    SLIDER_GRID_LRG = '(min-width: 1060px)',
    SLIDER_GRID_MED = '(min-width: 800px)',
    SLIDER_GRID_SML = '(min-width: 600px)',
    SLIDER_GRID_XSML = '(max-width: 599px)';

export {
    XLRG_IMAGE,
    LRG_IMAGE,
    MED_IMAGE,
    SML_IMAGE,
    DPR_1,
    DPR_2,
    SLIDER_GRID_LRG,
    SLIDER_GRID_MED,
    SLIDER_GRID_SML,
    SLIDER_GRID_XSML
};
